// extracted by mini-css-extract-plugin
export var image = "styles-module--image--c43b5";
export var item = "styles-module--item--8faba";
export var subTitle = "styles-module--subTitle--da89d";
export var text = "styles-module--text--017e1";
export var title = "styles-module--title--148b9";